import React, { useState } from "react";
import { Col, Row, Card, OverlayTrigger, Button } from "react-bootstrap";
import SplitNumber from "../../../components/SplitNumber";
import { useLocation, Link } from "react-router-dom";
// import LazyLoad from "react-lazyload";
import { isMobile } from "react-device-detect";
// import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import SmallImage from "./SmallImage";
import _ from "lodash";
import { IconChevronLeft } from "../../../../assets/icons";

function OrderItemShow({ item, key }) {
  let location = useLocation();
  const sum = item.basketItems.reduce((accumulator, currentObject) => {
    return accumulator + currentObject.totalCount;
  }, 0);

  //
  return (
    <Col
      xs={12}
      lg={4}
      key={key}
      className="pt-1 mt-3 tab-border-bottom fs-085"
    >
      <Link
        className="text-dark"
        to={{
          pathname: "/order/orderDetail/" + item.id,
          state: {
            statusList: location?.state?.statusList,
            title: location?.state?.title,
            basketId: item.id,
          },
        }}
      >
        <Row className="px-1 px-md-2">
          <Card
            className="w-100 rounded-3 border-top-0 border-bottom-0 border-end-0 shadow-sm px-0"
            style={{ borderRight: "5px solid #09a463" }}
          >
            <Card.Body className="px-3">
              <Row>
                <Col xs>
                  <div>
                    <span className="pe-1 fs-07 text-secondary">کد سفارش:</span>
                    {item.id}
                  </div>
                  <div className="pt-2">
                    <span className="pe-1 fs-07 text-secondary">مبلغ:</span>
                    <span className="fw-bold">
                      <SplitNumber number={item.price}></SplitNumber>
                    </span>
                    <span className="fs-075"> تومان</span>
                  </div>
                </Col>
                <Col xs="auto" className="text-end fs-08">
                  <div className="">{item.lastModified}</div>

                  <div className="pt-2">
                    <span className="pe-1 fs-07 text-secondary ">تعداد :</span>
                    <span className="fw-bold pe-1">{sum}</span>
                    بلیط
                  </div>
                </Col>
              </Row>

              <Row className="pt-2 border-top mt-2 ">
                <Col xs="auto" className="my-auto">
                  <Button
                    variant="primary"
                    className="fs-075 mt-1 bg-white rounded-2 bg-light-3 py-1 px-2 small-svg"
                  >
                    مشاهده
                    <IconChevronLeft fillColor="white" />
                  </Button>
                </Col>
                <Col className="text-end ps-0">
                  <div className="d-flex aling-items-center justify-content-end order-image">
                    {!_.isEmpty(item.basketItems) &&
                      item.basketItems?.map((basketItem, index2) => (
                        <SmallImage
                          basketItem={basketItem}
                          item={item}
                          index2={index2}
                        />
                      ))}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Row>
      </Link>
    </Col>
  );
}
export default OrderItemShow;
